import Button from "components/ui/button"
import Picture from "components/ui/picture"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const WhatsCovered = () => {
  return (
    <>
      <div className="desktop:gap-40 desktop:grid-[420px_1fr] desktop:py-60 grid grid-cols-1 items-center gap-20 py-16">
        <div>
          <h2 className="h2 mb-20">Additional Protection Coverage</h2>
          <p className="body mb-20">
            Jewlr has partnered with Extend to provide peace-of-mind protection
            for the {jewlr_t("jewelry")}{" "}
            {sl.config.enable_watches ? "and watches " : ""}you love.
          </p>
          <p className="body">
            Extend bundles your personalized pieces with an affordable
            protection plan which you add to your purchase during
            checkout&ndash;so your {jewlr_t("jewelry")} is covered, even after
            the manufacturer&apos;s warranty expires.
          </p>
        </div>
        <Picture
          alt="An example of Extend protection coverage options"
          fallback="https://cms.jewlr.com/additional_protection_coverage_2x_e90cd66505/additional_protection_coverage_2x_e90cd66505.jpg"
          srcSet={[
            {
              height: 601,
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_additional_protection_coverage_2x_8b6d7bdd01/m_additional_protection_coverage_2x_8b6d7bdd01.jpg`,
                686
              ),
              width: 686,
            },
            {
              height: 1001,
              media: "(min-width: 768px)",
              sizes:
                "(max-width: 1023px) 100vw, (max-width: 1920px) calc(100vw - 420px), 950px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/additional_protection_coverage_2x_e90cd66505/additional_protection_coverage_2x_e90cd66505.jpg`,
                2120
              ),
              width: 2120,
            },
          ]}
        />
      </div>
      <div className="desktop:flex-row desktop:gap-40 desktop:py-60 flex flex-col justify-between gap-20 py-24">
        <h2 className="display-md flex-1">
          What&apos;s <br />
          Covered
        </h2>
        <div className="desktop:gap-40 tablet:grid-cols-2 grid flex-1 grid-cols-1 gap-20">
          <div>
            <h3 className="h3 font-bold">Replacement or Repair</h3>
            <p className="body">
              Free replacement or repair if something should happen to your
              {jewlr_t("jewelry")}
              {sl.config.enable_watches ? " or watch" : ""}.
            </p>
          </div>
          <div>
            <h3 className="h3 font-bold">Peace of Mind</h3>
            <p className="body">
              Wear your {jewlr_t("jewelry")}{" "}
              {sl.config.enable_watches ? "and watch " : ""}with
              confidence&ndash;we have you covered!
            </p>
          </div>
          <div>
            <h3 className="h3 font-bold">Zero Deductible</h3>
            <p className="body">
              No fees. No deductibles. No hidden costs to repair your{" "}
              {jewlr_t("jewelry")}.
            </p>
          </div>
          <div>
            <h3 className="h3 font-bold">Customer Focused Support</h3>
            <p className="body">We&apos;re always happy to help.</p>
          </div>
          <div>
            <h3 className="h3 font-bold">Accidental Damage</h3>
            <p className="body">
              Your {jewlr_t("jewelry")} is protected when accidental damage
              occurs.
            </p>
          </div>
          <div>
            <h3 className="h3 font-bold">
              Added {jewlr_t("Jewelry")} Benefits
            </h3>
            <p className="body">
              Free ring sizing, rhodium plating, polishing, and more!
            </p>
          </div>
        </div>
      </div>
      <div className="desktop:grid-cols-[1fr_420px] desktop:pb-60 desktop:pt-60 grid grid-cols-1 items-center gap-16 pb-56 pt-16">
        <Picture
          alt="Sample screenshot of contacting Extend for making a claim"
          fallback="https://cms.jewlr.com/whats_covered_2x_898797c7e8/whats_covered_2x_898797c7e8.jpg"
          srcSet={[
            {
              height: 601,
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_whats_covered_2x_0d69282e3c/m_whats_covered_2x_0d69282e3c.jpg`,
                686
              ),
              width: 686,
            },
            {
              height: 1001,
              media: "(min-width: 768px)",
              sizes:
                "(max-width: 1023px) 100vw, (max-width: 1920px) calc(100vw - 420px), 974px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/whats_covered_2x_898797c7e8/whats_covered_2x_898797c7e8.jpg`,
                1956
              ),
              width: 1956,
            },
          ]}
        />
        <div>
          <div className="desktop:mb-60 mb-48">
            <h2 className="h2 mb-20">Simple Peace-of-Mind Protection</h2>
            <p className="body">
              You pay one flat rate at checkout and when you need it, Extend
              will work directly with us to get your product repaired quickly.
              Getting your replacement is seamless and simple.
            </p>
          </div>
          <div>
            <h2 className="h2 mb-20">What If I Need To Make A Claim</h2>
            <p className="body">
              Processing your claim takes minutes and you&apos;ll receive
              everything you need for a repair or replacement. Simply{" "}
              <Button asChild underline>
                <a
                  href="https://customers.extend.com/claims"
                  rel="nofollow noopener"
                >
                  contact Extend
                </a>
              </Button>{" "}
              online or by phone at{" "}
              <Button asChild underline>
                <a href="tel:877-248-7707">(877) 248-7707</a>
              </Button>
              . Easy as pie!
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhatsCovered
